<template>
  <div>
    <div
      class="card mb-2"
      v-if="$props.property.MediaFiles && $props.property.MediaFiles.length > 0"
    >
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex justify-content-between align-items-center font-weight-bold text-muted mb-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="ui.show = !ui.show"
          >
            Media
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="removeAllRules"
            :disabled="$props.disabled || $props.value.length === 0 || $props.value.some(r => r.scope === RuleScopeLogin)"
          >
            Delete Rules
          </button>
        </h5>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <div class="form-row">
          <div class="col">
            <div
              v-if="error.show"
              class="alert alert-warning"
            >
              {{ error.msg }}
            </div>
            <template v-for="(media, i) in $props.property.MediaFiles">
              <div
                :class="`input-group ${i === $props.property.MediaFiles.length - 1 ? '' : 'mb-2'}`"
                :key="media.URL+media.Type"
              >
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                  >
                    {{ mediaLabels[media.Type] }}
                  </div>
                </div>
                <input
                  type="url"
                  :value="media.URL"
                  disabled
                  :class="{
                    'form-control': true,
                    'rule-none': classes[media.URL].ruleNone,
                    'rule-remove': classes[media.URL].ruleRemove
                  }"
                >
                <div class="input-group-append">
                  <button
                    class="btn btn-primary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  />
                  <div class="dropdown-menu">
                    <a
                      :href="media.URL"
                      target="_blank"
                      class="dropdown-item"
                    >
                      Open
                    </a>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="update(media, RuleScopeProperty)"
                      :disabled="$props.disabled || $props.value.find( r=> r.mediaType === media.Type && r.mediaURL === media.URL && r.key === RuleKeyRemove && r.scope === RuleScopeLogin )"
                    >
                      Mark as {{ $props.value.find( r=> r.mediaType === media.Type && r.mediaURL === media.URL && r.key === RuleKeyRemove && r.scope === RuleScopeProperty ) ? 'Visible' : 'Hidden' }}
                    </button>
                    <div
                      role="separator"
                      class="dropdown-divider"
                    />
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="update(media, RuleScopeLogin)"
                      :disabled="$props.disabled || $props.value.find( r=> r.mediaType === media.Type && r.mediaURL === media.URL && r.key === RuleKeyRemove && r.scope === RuleScopeProperty )"
                    >
                      Mark as {{ $props.value.find( r=> r.mediaType === media.Type && r.mediaURL === media.URL && r.key === RuleKeyRemove && r.scope === RuleScopeLogin ) ? 'Visible' : 'Hidden' }} for all properties from {{ $props.property.Login }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mediaLabels } from '../common';
import { RuleScopeLogin, RuleScopeProperty } from '../consts';

import {
    makeMediaRule,
    RuleKeyRemove
} from '../rules/media';

export default {
    data: () => ( {
        ui: {
            show: true
        },
        error: {
            show: false,
            msg: ''
        }
    } ),
    computed: {
        classes() {
            let classes = {};

            this.$props.property.MediaFiles.forEach( media => {
                let found = this.$props.value.find( r => r.mediaType === media.Type && r.mediaURL === media.URL && r.key === RuleKeyRemove );
                classes[ media.URL ] = {
                    ruleNone: found ? false : true,
                    ruleRemove: found ? true : false
                };
            } );

            return classes;
        }
    },
    methods: {
        validate() {
            let state = {
                valid: true,
                msg: ''
            };

            return state;
        },
        update( media, scope ) {
            this.error.show = false;

            const exists = this.$props.value.find( rule => rule.mediaType === media.Type && rule.mediaURL === media.URL && rule.key === RuleKeyRemove && rule.scope === scope );

            const action = exists ? 'unhide' : 'hide';

            if ( scope === RuleScopeLogin ) {
                const continueAdd = confirm( `Are you sure you want to ${action} this ${mediaLabels[ media.Type ]} for login ${this.$props.property.Login}` );

                if ( !continueAdd ) {
                    return;
                }
            }

            const result = makeMediaRule( {
                mediaType: media.Type,
                mediaURL: media.URL,
                key: RuleKeyRemove,
                createdBy: this.$store.getters.email,
                scope: scope
            } );

            if ( result.error !== null ) {
                this.error.show = true;
                this.error.msg = result.error.toString();
                return;
            }

            let rules = [];

            if ( exists ) {
                for ( let i = 0; i < this.$props.value.length; i++ ) {
                    if ( this.$props.value[ i ].mediaType === media.Type && this.$props.value[ i ].mediaURL === media.URL && this.$props.value[ i ].key === RuleKeyRemove && this.$props.value[ i ].scope === scope ) {
                        continue;
                    }
                    rules.push( this.$props.value[ i ] );
                }
                
                this.$emit( 'input', rules );
                return;
            }

            rules = this.$props.value;
            rules.push( result.rule );

            this.$emit( 'input', rules );
        },
        removeAllRules() {
            this.$emit( 'input', [] );
        },
        reset() {
            this.ui = this.initialState;
        }
    },
    created() {
        this.mediaLabels = mediaLabels;
        this.initialState = this.ui;
        this.RuleKeyRemove = RuleKeyRemove;
        this.RuleScopeProperty = RuleScopeProperty;
        this.RuleScopeLogin = RuleScopeLogin;
    },
    props: {
        property: {
            required: true,
            type: Object,
            default: () => ( {
                MediaFiles: []
            } )
        },
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/MediaFileRuleHandler.vue